import React from 'react';
import {RouterProvider, createBrowserRouter} from 'react-router-dom';

import {Routes} from '../routes';
import {screens} from '../screens';
import {admin} from '../screens/admin';

import { ProtectedRoute } from '../routes/ProtectedRoutes';
import {TabNavigator} from './TabNavigator';

const stack = createBrowserRouter([
  {
    path: Routes.SignIn,
    element: <screens.SignIn />,
  },
  {
    path: Routes.ForgotPassword,
    element: <screens.ForgotPassword />,
  },
  {
    path: Routes.ForgotPasswordSentEmail,
    element: <screens.ForgotPasswordSentEmail />,
  },
  {
    path: Routes.SignUp,
    element: <screens.SignUp />,
  },
  {
    path: Routes.Reviews,
    element: <screens.Reviews />,
  },
  {
    path: Routes.MenuList,
    element: <screens.MenuList />,
  },
  {
    path: Routes.NewPassword,
    element: <screens.NewPassword />,
  },
  {
    path: Routes.Filter,
    element: <screens.Filter />,
  },
  {
    path: Routes.OrderHistory,
    element: <screens.OrderHistory />,
  },
  {
    path: Routes.Promocodes,
    element: <screens.Promocodes />,
  },
  {
    path: Routes.OrderSuccessful,
    element: <screens.OrderSuccessful />,
  },
  {
    path: Routes.OrderFailed,
    element: <screens.OrderFailed />,
  },
  {
    path: Routes.PromocodesEmpty,
    element: <screens.PromocodesEmpty />,
  },
  {
    path: Routes.LeaveAReview,
    element: <screens.LeaveAReview />,
  },
  {
    path: Routes.Onboarding,
    element: <screens.Onboarding />,
  },
  {
    path: Routes.OrderHistoryEmpty,
    element: <screens.OrderHistoryEmpty />,
  },
  {
    path: Routes.TrackYourOrder,
    element: <screens.TrackYourOrder />,
  },
  {
    path: Routes.Checkout,
    element: <screens.Checkout />,
  },
  {
    path: Routes.Search,
    element: <screens.Search />,
  },
  {
    path: Routes.ConfirmationCode,
    element: <screens.ConfirmationCode />,
  },
  {
    path: Routes.SignUpAccountCreated,
    element: <screens.SignUpAccountCreated />,
  },
  {
    path: Routes.VerifyYourPhoneNumber,
    element: <screens.VerifyYourPhoneNumber />,
  },
  {
    path: Routes.Dish,
    element: <screens.Dish />,
  },
  {
    path: Routes.EditProfile,
    element: <screens.EditProfile />,
  },
  {
    path: Routes.TabNavigator,
    element: <TabNavigator />,
  },
  {
    path: Routes.Activities,
    element: <screens.Activities />,
  },
  {
    path: Routes.Partners,
    element: <screens.Partners />,
  },
  {
    path: Routes.Articles,
    element: <screens.Articles />,
  },
  {
    path: Routes.MySons,
    element: <screens.MySons />,
  },
  {
    path: Routes.ExtraCurricular,
    element: <screens.ExtraCurricular />,
  },
  // {
  //   path: Routes.Academy,
  //   element: <screens.Academy />,
  // },
  {
    path: Routes.DetailActivities,
    element: <screens.DetailActivities />,
  },
  {
    path: Routes.DetailArticles,
    element: <screens.DetailArticles />,
  },
  {
    path: Routes.DetailExtraCurriculars,
    element: <screens.DetailExtraCurriculars />,
  },
  {
    path: Routes.DetailPartners,
    element: <screens.DetailPartners />,
  },
  {
    path: Routes.DetailSons,
    element: <screens.DetailSons />,
  },
  {
    path: Routes.DetailSonsSubjects,
    element: <screens.DetailSonsSubjects />,
  },
  {
    path: Routes.DetailSonsRaport,
    element: <screens.DetailSonsRaport />,
  },
  {
    path: Routes.DetailSonsRkh,
    element: <screens.DetailSonsRkh />,
  },
  {
    path: Routes.DetailSonsAbsensi,
    element: <screens.DetailSonsAbsensi />,
  },
  {
    path: Routes.DetailSonsGradeAnalysis,
    element: <screens.DetailSonsGradeAnalysis />,
  },
  {
    path: Routes.Creation,
    element: <screens.Creation />,
  },
  {
    path: Routes.DetailCreation,
    element: <screens.DetailCreation />,
  },
  {
    path: Routes.DetailAcademy,
    element: <screens.DetailAcademy />,
  },
  {
    path: Routes.ClockInSuccess,
    element: <screens.ClockInSuccess />,
  },
{
  path: Routes.PatrolFormTable,
  element: <admin.PatrolFormTable />
},
{
  path: `${Routes.PatrolDetailPage}/:patrolId`,
  element: <admin.PatrolDetailPage />

},
{
  path: `${Routes.PatrolDetailPage}/:patrolId/add-spot`,
  element: <admin.AddSpotPage />

},
// {
//   path: `${Routes.PatrolDetailPage}/:patrolId/edit-spot/:spotId`,
//   element: (
//     <ProtectedRoute allowedRoles={['security_admin']}>
//       <admin.EditSpotPage />
//     </ProtectedRoute>
//   ),
// },
{
  path: Routes.PatrolUser,
  element: <admin.PatrolUser />

},
{
  path: Routes.PatrolUserForm,
  element: <admin.PatrolUserForm />
},
// {
//   path: `${Routes.PatrolUserDetail}/:Id`,
//   element: (
//     <ProtectedRoute allowedRoles={['admin','security_admin', 'developer']}>
//       <admin.PatrolUserDetail />
//     </ProtectedRoute>
//   ),
// },
{
  path: Routes.Unauthorize,
  element: <admin.UnauthorizedPage />,
},
{
  path: Routes.KelolaPatrol,
  element: <admin.KelolaPatrol />
},
{
  path: Routes.CreateGroup,
  element:
      <admin.CreateGroup />
},
{
  path: Routes.GroupSpace,
  element: <admin.GroupSpace />
},
{
  path: `${Routes.AssignUsersToGroup}/:groupId`,
  element:<admin.AssignUsersToGroup />

}

]);

export const StackNavigator: React.FC = () => {
  return <RouterProvider router={stack} />;
};
